import { types } from '../../actions';

const initialState = null;

export default function dashboardReducer(state = initialState, action) {
    switch (action.type) {
        case types.FETCH_DASHBOARD_SUCCESS:
            return action.payload;

        case types.FETCH_DASHBOARD_RESET:
            return initialState;

        default:
            return state;
    }
}
